import 'bootstrap'
import 'lightbox2/dist/js/lightbox-plus-jquery'

import './directives'

import './components'
import './layout'

import App from './app'


App.config.compilerOptions.isCustomElement = tag => tag === 'style' || tag === 'hgroup'


App.mount('#app')
